<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Display Container Update Log</md-dialog-title>
         <div style="width:80%;margin-left:25px;height:50px;">
            <div class = "leftbox">
             <md-field>
               <label>Container #</label>
               <md-input v-model="dataForm.containerNo" disabled/>
             </md-field>
          </div>
            <div class = "middlebox">
             <md-field>
               <label>Load Key</label>
               <md-input v-model="dataForm.seqNo" disabled/>
             </md-field>
          </div>
            <div class = "rightbox">
             <md-field>
               <label>Log On</label>
               <md-input v-model="dataForm.fields" disabled/>
             </md-field>
          </div>
         <div class="closebtn">
          <md-button class="custButton btn-search-special-form-container md-primary md-raised" @click="showDialog = false">Close</md-button>
         </div>
         </div>
      <md-dialog-content>
        <form>
    
          <pagination :items="filteredRows">
             <template slot-scope="{pageItems}">
                <md-card class="data-table-container setzindex">
                    <div class="outer-container">
                        <div class="inner-container table-wrapper">
                            <div class="table-header">
                                <table id="headertable">
                                    <thead>
                                        <tr>
                                          <th class="header-cell center w5" v-on:click="sortFunction('oldValue')">Old Status</th>
                                          <th class="header-cell center w5" v-on:click="sortFunction('newValue')">New Status</th>
                                          <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">Created By</th>
                                          <th class="header-cell center w10" v-on:click="sortFunction('createdAt')">Created At</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div class="table-body" @scroll="handleScroll">
                                <table id="bodytable">
                                   <tbody>
                                      <tr :key="item.vueKey" v-for="item in pageItems"
                                          v-bind:class ="{ selected: item.selected}">
                                          <td class="body-cell excelBox w5">{{item.oldValue}}</td>
                                          <td class="body-cell excelBox w5">{{item.newValue}}</td>
                                          <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                                          <td class="body-cell excelBox w10">{{item.createdAt}}</td>
                                        </tr>
                                   </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </md-card>
             </template>
          </pagination> 


        </form>
        <!--
        <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
          </md-dialog-actions>
        -->
      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  form {
    min-width: 640px;
    min-height: 250px;
    margin: 24px;
  }
  .leftbox {
     float:left;
     width:25%;
     height: 100px;
     margin-right:10px;
  }
  .middlebox {
     float:left;
     width:25%;
     height: 100px;
     margin-left:20px;
     margin-right:10px;
  }
  .rightbox {
    float:left;
    width:25%;
    height:100px;
    margin-left: 20px;
  }
  .closebtn {
    float:left;
    width:10%;
    margin-left:20px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import Pagination from './Pagination.vue';

  const getInitialDataForm = () => ({
    seqNo: null,
    containerNo: null,
    chassisNo: null,
    sealNumber: null,
    loadStatus: null,
    fields: null,
  });

  const getInitialReq = () => ({
    office: null,
    seqNo: null,
    fields: null,
    createdBy: null,
    createdAt: null,
  });

  export default {
    components: {Pagination},
    mixins: [validationMixin],
    props: { action: Function},
    data: () => ({
      showDialog: false,
      //application: null,
      dataForm: getInitialDataForm(),
      reqForm: getInitialReq(),
      reqs: [],
      items: [],
      statusList: [],
      browsername: null,  
    }),
    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getUserProfile',
      ]),
      filteredRows(){
        return this.items;
      },
      getPickupLocationOptions() {
        const { ccicSupplierGroup } = this.getUserProfile;
        if (ccicSupplierGroup) {
          return this.getMasterDataAsSelectOptionByGroup(ccicSupplierGroup);
        }
        return [];
      },
      // sortStatus: function () {
      //    function compare(a,b) {
      //      if (a.tagId < b.tagId)
      //        return 1;
      //      if (a.tagId > b.tagId)
      //        return -1;
      //      return 0;    
      //    }
      //    return this.statusList.sort(compare);
      // },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          this.$store.commit('clearApiError');
        }
      },
      // 'dataForm.disapprove'(val) {
      //   if (val === 'REJECT' || val === 'UNLOAD&REJECT') {
      //     this.dataForm.newSeal = '';
      //   }
      // },
    },
    // validations: {
    //   dataForm: {
    //     newSeal: {
    //       required(val) {
    //         if (this.dataForm.type === 'CHECK_POINT' && (this.dataForm.disapprove === 'UNLOAD' || this.dataForm.disapprove === 'APPROVE')) {
    //           return !!val;
    //         }
    //         return true;
    //       },
    //     },
    //   },
    // },
    methods: {
      async openDialog(container) {
        //this.dataForm = JSON.parse(JSON.stringify(container));
         this.dataForm.seqNo = container.seqNo;
         this.dataForm.containerNo = container.containerNo;
         this.dataForm.chassisNo = container.chassisNo;
         this.dataForm.sealNumber = container.sealNumber;
         this.dataForm.loadStatus = container.loadStatus;
         this.dataForm.fields = "LOAD STATUS";
        // this.reqForm.seqNo = container.seqNo;
        // this.reqForm.containerNo = container.containerNo;
        // this.reqForm.chassisNo = container.chassisNo;
        // this.reqForm.appointment = container.appointment;
        // this.reqForm.apptDate = container.apptDate;
        // this.reqForm.apptTime = container.apptTime;
        // this.reqForm.dispatcherInstruction = container.dispatcherInstruction;
        // this.reqForm.pushStatus = container.pushStatus;
        // this.reqForm.driverGroup = container.driverGroup;
        // this.reqForm.driverId = container.driverId;
        // this.reqForm.loadStatus = container.loadStatus;
        // //this.$v.dataForm.$reset();

        // //this.statusList = this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS').filter( (it) => { it.tagId != 'BLC' && it.tagId != 'CFM' && it.tagId != 'LOK'});
        // this.items = this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS');
        // //this.statusList = this.statusList.filter( (st) => {st.tag != "CFM"});
        // this.getLoadStatusWithFilter(this.items);

        // console.log("statusList: " + JSON.stringify(this.statusList));
        console.log("seqNo: " + container.loadStatus);
        this.reqForm.office = "STC";
        this.reqForm.seqNo = container.seqNo;
        this.reqForm.fields = "LOAD STATUS";
        //await api.post('/api/w/stc/getcontainerupdatelog',this.reqForm)
        await newAPIPost('/api/w/stc/getcontainerupdatelog',this.reqForm)
           .then((logs) => {
              this.items = logs;
              console.log("log: " + JSON.stringify(this.items));
           })
        if (this.items.length > 0) {  
           const browserversion = navigator.userAgent;
           this.browsername = browserversion.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
           console.log("browser: " + this.browsername[1]);
           if (this.browsername[1].toString().toUpperCase() == "CHROME") {
             //this.statusList = this.statusList.sort((a,b) => a.tagId - b.tagId);
             this.items = this.items.sort(function(a,b) {
                return a.createdAt < b.createdAt? 1 : -1;
             })
           }  
           else 
             this.items = this.items.sort((a,b) => a.createdAt < b.createdAt);
          
           this.showDialog = true;
        }   
        else {
           alert("No load status log can be found for container - " + container.containerNo + "!!");
           this.showDialog = false;
        }   
      },
      // getValidationClass(fieldName) {
      //   const field = _(this.$v)
      //     .lookup(fieldName);
      //   if (field) {
      //     return {
      //       'md-invalid': field.$invalid && field.$dirty,
      //     };
      //   }
      //   return {};
      // },
      handleLoadStatusChanged(id) {
         this.dataForm.loadStatus = this.getContentFromBrace(id);
      },
      getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
      },
      doSave() {
        //this.$v.dataForm.$touch();
        //console.log(this.$v.dataForm.$invalid);
        //if (this.$v.dataForm.$invalid) {
        //  return;
        //}
        if (this.dataForm.loadStatus == null || this.dataForm.loadStatus == "")
        {
            alert("Unable to save: Load Status is empty!!");
            return;
        }   
        this.reqForm.loadStatus = this.getContentFromBrace(this.dataForm.loadStatus);
        console.log("dataForm: " + JSON.stringify(this.dataForm));
        console.log("reqForm: " + JSON.stringify(this.reqForm));
        this.reqs.push(this.reqForm);
        this.showDialog = false;
        this.action(this.getContentFromBrace(this.dataForm.loadStatus));
        //api.post("/api/w/gst/updateyardstage", this.reqs)
        newAPIPost("/api/w/gst/updateyardstage", this.reqs)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action(this.dataForm.loadStatus)
            $('.btn-search-ccic-container')
              .click();
          });
      },
      getLoadStatusWithFilter(items) {
        if (items && items.length > 0) {
           var itemscount = items.length;
           while (itemscount > 0) {
              var item = items.pop()
              if (item.tagId != "CFM" && item.tagId != "LOK" && item.tagId != "BLC") {
                 this.statusList.push(item);
              }
              itemscount -= 1;
           }
           this.statusList = this.statusList.sort((a,b) => a.tagId > b.tagId);
        }
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

    },
  };


</script>
